export const groupingFields = ['takeOffType', 'level', 'imageName', 'usage'] as const;
